import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { KnowledgeListPageModule } from "@comunicare/comunicare-knowledge-list";
import { TranslateModule } from "@ngx-translate/core";
import { KnowledgeListContainerPageComponent } from "./knowledge-list-container-page.component";

@NgModule({
  declarations: [KnowledgeListContainerPageComponent],
  imports: [
    CommonModule,
    TranslateModule,
    KnowledgeListPageModule,
    RouterModule.forChild([{ path: "", component: KnowledgeListContainerPageComponent }]),
  ],
  exports: [KnowledgeListContainerPageComponent],
})
export class KnowledgeListContainerPageModule {}
